import React from 'react';
import LogList from '../components/LogList';
import PageHeader from '../components/common/PageHeader';
import PageContainer from '../components/common/PageContainer';

function Settings() {
  return (
    <PageContainer>
      <PageHeader title="システム設定" />
      <LogList />
    </PageContainer>
  );
}

export default Settings;
